import { render, staticRenderFns } from "./RankingPerTeams.vue?vue&type=template&id=78dc8084&"
import script from "./RankingPerTeams.vue?vue&type=script&lang=js&"
export * from "./RankingPerTeams.vue?vue&type=script&lang=js&"
import style0 from "./RankingPerTeams.vue?vue&type=style&index=0&id=78dc8084&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports